module.exports = __webpack_public_path__ + "static/logo-green-3d51f73e83d5360e0496c5bffd74865d.png";